module.exports = __webpack_public_path__ + "img/134.b379b934.jpg";